import { Component, OnInit } from '@angular/core';
// import { Title } from '@angular/platform-browser';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { environment } from '../../../../../environments/environment';
import { User } from '../../../../models/user';
import { AuthService } from '../../../../shared/services/auth.service';
// import { fadeInOutTranslate } from 'src/app/shared/elements/animation';
// import {Guardian} from '../../../../models/guardian';
// import { fadeInOutTranslate } from '../../../../../shared/elements/animation';


@Component({
	selector: 'app-mark-student-attendance',
	templateUrl: './mark-student-attendance.component.html',
	styleUrls: ['./mark-student-attendance.component.css'],
	// animations: [fadeInOutTranslate]
})
export class MarkStudentAttendanceComponent implements OnInit {
	title = 'Mark Attendance';
	safeSrc: SafeResourceUrl;
	private url = `${environment.main_url}react/index.html?page=${window.location.pathname}`
	loginUser: User;
	// best.geitt.com/react' + window.location.pathname

	constructor(
		private _title: Title,
		private sanitizer: DomSanitizer,
		private _auth: AuthService
	) {
		this.loginUser = this._auth.getLoginUser();
		this.url += `&token=${this.loginUser.key}`
		this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
	}

	ngOnInit() {
		// console.log(this.url)
		// this.loginUser = this._auth.getLoginUser();
		// this._title.setTitle(this.title);
	}


}
